/**
 * Store complete book models (photos, backgrounds, stickers, etc...)
 */
fx.ns("repositories", class PosterRepository extends repositories.BaseRepository {

    constructor() 
    {
        super({
            creation: new models.ProductPoster({ id: "" }), // id empty so it's not created in db 
            zoom : new models.Zoom(),
        });
    }

    get layoutid()
    {
        return this._layoutid;
    }

    get createdFromLayout()
    {
        return !!this.layoutid || !!this.layout;
    }

    set layoutid(val)
    {
        this._layoutid = val;
    }

    get poster()
    {
        return this.creation;
    }

    create()
    {
        this.post( "/app/create", {  product_id : this.productid, 
                                     formatid : this.choosedFormat, 
                                     optionid : this.creationProductOption.id,
                                     layoutid : this.layoutid 
                                    }, 
                                     this.onCreateData);

        this.event("create-creation");
    }

    getOptions()
    {
        this.post( "/app/options", {  creationid : this.creation.id, formatid : this.creation.formatid}, this._onOptionsData);
    }

    initData(data)
    {
        super.initData(data);

        this.poster.init(data.creation, {"CreationElement" : "ProductPosterPage"});

        this.creation.creationOptions = data.creationOptions;

        if (data.layout)
            this.layout = new models.ThemeLayout( data.layout );
    }

    addPhotosForCreation()
    {
        this.creation.addPhotosForCreation();
    }
   

});
